import { breakpoints, Inline, Radio, Stack } from '@etg/wings';
import { css } from '@eti/styles';
import BaggageSelectionPriceInformation from './BaggageSelectionPriceInformation';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const baggageSelectionPriceInformationStyle = css`
  flex-direction: column;

  @media (min-width: ${breakpoints._560}) {
    flex-direction: row;
    flex-grow: 1;
  }
`;
const BaggageSelectionRadioBoxLabel = _ref => {
  let {
    baggageOption,
    input,
    order,
    productName,
    secondBagProductId,
    setYesOptionRef
  } = _ref;
  const {
    id,
    value
  } = baggageOption;
  return /*#__PURE__*/_jsx(Radio.Label, {
    "data-offer-rate": secondBagProductId,
    "data-testid": `toggleChoice-${productName}-${id}`,
    htmlFor: `custom-option-${productName}-${id}`,
    children: /*#__PURE__*/_jsxs(Inline, {
      noWrap: true,
      children: [/*#__PURE__*/_jsx(Radio, {
        id: `custom-option-${productName}-${id}`,
        ref: element => {
          const isSelected = value === (input === null || input === void 0 ? void 0 : input.value);
          if (isSelected) {
            setYesOptionRef(element);
          }
        },
        value: value
      }), /*#__PURE__*/_jsx(Stack, {
        className: baggageSelectionPriceInformationStyle,
        children: /*#__PURE__*/_jsx(BaggageSelectionPriceInformation, {
          baggageOption: baggageOption,
          order: order,
          productName: productName
        })
      })]
    })
  }, `custom-option-${productName}-${id}`);
};
export default BaggageSelectionRadioBoxLabel;
//# sourceMappingURL=BaggageSelectionRadioBoxLabel.js.map